import { useCallback } from 'react';
import qs from 'query-string';

const encarFemCarUrl = process.env.REACT_APP_ENCAR_FEM_CAR;

const useGoSearchList = () => {
	const goSearchList = useCallback((nav, { params, vehicleType } = {}) => {
		const mobileListUrl = (vehicleType ?? 'CAR') === 'CAR' ? `${encarFemCarUrl}/list/car` : `${encarFemCarUrl}/list/truck`;

		let url = `${mobileListUrl}?page=1&search=${encodeURIComponent(JSON.stringify(nav))}`;
		if (params) url += `&${qs.stringify(params)}`;
		window.location.href = url;
	}, []);

	return { goSearchList };
};

export default useGoSearchList;
